import React from "react";
import { FaArchway } from "react-icons/fa";
import { FaHouzz } from "react-icons/fa6";

export default function HouseOffer() {
  return (
    <>
      <section className="house-offer-section fix section-padding">
        <div className="container">
          <div className="section-title text-center">
            {/* <h5 className="wow fadeInUp">
              <i className="fa fa-angle-double-left" aria-hidden="true"></i>{" "}
              Highlights & Amenities{" "}
              <i className="fa fa-angle-double-right" aria-hidden="true"></i>
            </h5> */}
            <h2 className="wow fadeInUp aboutSectiontitle" data-wow-delay=".3s">
              Highlights & Amenities
            </h2>
          </div>
          <div className="row row-cols-xxl-4 row-cols-xl-4 row-cols-lg-2 row-cols-md-2 row-cols-sm-2 row-cols-1">
            <div className="col wow fadeInUp">
              <div className="house-offer-box section-bg-3 style-2">
                <div className="icon-1">
                  <FaArchway />
                </div>
                <div className="content">
                  <h4>Gated entrance with security cabin</h4>
                </div>
              </div>
            </div>
            <div className="col wow fadeInUp" data-wow-delay=".4s">
              <div className="house-offer-box section-bg-3 style-2">
                <div className="icon-1">
                  <FaHouzz />
                </div>
                <div className="content">
                  <h4>Clubhouse / Community hall</h4>
                </div>
              </div>
            </div>

            <div className="col wow fadeInUp" data-wow-delay=".8s">
              <div className="house-offer-box section-bg-3 style-2">
                <div className="icon-1">
                  <i className="flaticon-facility"></i>
                </div>
                <div className="content">
                  <h4>Indoor games room / Pool</h4>
                </div>
              </div>
            </div>
            <div className="col wow fadeInUp" data-wow-delay=".9s">
              <div className="house-offer-box section-bg-3 style-2">
                <div className="icon-1">
                  {/* <i className="flaticon-playground"></i> */}
                  <i className="fa fa-tree" aria-hidden="true"></i>
                </div>
                <div className="content">
                  <h4>Garden / landscaped lawns</h4>
                </div>
              </div>
            </div>
            <div className="col wow fadeInUp" data-wow-delay=".2s">
              <div className="house-offer-box section-bg-3 style-2">
                <div className="icon-1">
                  <i className="flaticon-parking"></i>
                </div>
                <div className="content">
                  <h4>Car Parking</h4>
                </div>
              </div>
            </div>
            <div className="col wow fadeInUp" data-wow-delay=".4s">
              <div className="house-offer-box section-bg-3 style-2">
                <div className="icon-1">
                  <i className="flaticon-dumbbell"></i>
                </div>
                <div className="content">
                  <h4>Fitness Center</h4>
                </div>
              </div>
            </div>
            <div className="col wow fadeInUp" data-wow-delay=".6s">
              <div className="house-offer-box section-bg-3 style-2">
                <div className="icon-1">
                  <i className="flaticon-pet-care"></i>
                </div>
                <div className="content">
                  <h4>Pet Friendly</h4>
                </div>
              </div>
            </div>

            <div className="col wow fadeInUp" data-wow-delay=".9s">
              <div className="house-offer-box section-bg-3 style-2">
                <div className="icon-1">
                  <i className="flaticon-playground"></i>
                </div>
                <div className="content">
                  <h4>Playground</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
